import { safeTrackCall } from '@/presentation/pages/common-analytics'
import { trackEvent } from '@/infra/tracking/analytics'

export namespace ContactVerificationAnalytics {
  export const trackPageView = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerificationPage_view', { location, contactType })
  })

  export const trackResend = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerification_resend', { location, contactType })
  })

  export const trackValidate = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerification_validate', { location, contactType })
  })

  export const trackSkip = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerification_skip', { location, contactType })
  })

  export const trackConfirmSuccess = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerification_confirm', { location, contactType })
  })

  export const trackConfirmError = safeTrackCall(
    (location: string, contactType: string, tries: number, error: string) => {
      trackEvent('up_contactVerification_confirmError', { location, contactType, tries, error })
    }
  )

  export const trackSuccessView = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerification_successView', { location, contactType })
  })

  export const trackSuccessContinue = safeTrackCall((location: string, contactType: string) => {
    trackEvent('up_contactVerification_successContinue', { location, contactType })
  })

  export const trackPhone = safeTrackCall((location: string) => {
    trackEvent('up_contactVerification_phone', { location })
  })

  export const trackEmail = safeTrackCall((location: string) => {
    trackEvent('up_contactVerification_email', { location })
  })
}
